import { separateOptionalPaths } from '@virtuslab/nfs-shared/src/services/routes';

import { contractParamName } from './component';

export const BaseRoutes = separateOptionalPaths({
  BASE: '/',
  CONTRACT_ROUTE: `/c/:${contractParamName}`,
} as const);

export const LoginRoutes = separateOptionalPaths({
  LOGIN: '/auth/login',
} as const);

export const LogoutRoutes = separateOptionalPaths({
  LOGOUT: '/auth/logout',
} as const);

export const BusinessTravelsRoutes = separateOptionalPaths({
  BUSINESS_TRAVELS: `/business-travels`,
} as const);

export const AbsencesRoutes = separateOptionalPaths({
  ABSENCES: `/absences`,
  ABSENCES_FOR_DATE: `/absences/:year/:month`,
} as const);

export const OfficeRoutes = separateOptionalPaths({
  OFFICE: `/office-and-spots`,
} as const);

export const DashboardRoutes = separateOptionalPaths({
  DASHBOARD: `/dashboard`,
} as const);

export const BenefitsRoutes = separateOptionalPaths({
  BENEFITS: `/benefits`,
} as const);

export const SettingsRoutes = separateOptionalPaths({
  SETTINGS: `/settings`,
} as const);

export const ProjectRoutes = separateOptionalPaths({
  PROJECTS: `/projects`,
} as const);

export const DirectReportingRoutes = separateOptionalPaths({
  DIRECT_REPORTING: `/direct-reporting`,
} as const);

export const ProgressionRoutes = separateOptionalPaths({
  PROGRESSION: `/progression`,
} as const);

export const MyProfileRoutes = separateOptionalPaths({
  MY_PROFILE: `/my-profile`,
} as const);

export const TimeReportRoutes = separateOptionalPaths({
  TIME_REPORT: `${BaseRoutes.CONTRACT_ROUTE}/time-report`,
  TIME_REPORT_MONTHLY: `${BaseRoutes.CONTRACT_ROUTE}/time-report/monthly/:year/:month`,
  TIME_REPORT_MONTHLY_FINANCES: `${BaseRoutes.CONTRACT_ROUTE}/time-report/monthly/:year/:month/finances`,
  TIME_REPORT_MONTHLY_WORK_TIME: `${BaseRoutes.CONTRACT_ROUTE}/time-report/monthly/:year/:month/work_time`,
  TIME_REPORT_MONTHLY_LEAVE_AND_TRAINING: `${BaseRoutes.CONTRACT_ROUTE}/time-report/monthly/:year/:month/leave_and_training`,
  TIME_REPORT_MONTHLY_CALENDAR: `${BaseRoutes.CONTRACT_ROUTE}/time-report/monthly/:year/:month/calendar`,
} as const);

export const NotFoundRoutes = separateOptionalPaths({
  NOT_FOUND: '/404',
  FALLBACK: '*',
});
